module.exports = __webpack_public_path__ + "static/media/anlookBanner1.3517689d.png";